import { render, staticRenderFns } from "./TaskCreateCurrent.vue?vue&type=template&id=3c363648&scoped=true"
import script from "./TaskCreateCurrent.vue?vue&type=script&lang=js"
export * from "./TaskCreateCurrent.vue?vue&type=script&lang=js"
import style0 from "./TaskCreateCurrent.vue?vue&type=style&index=0&id=3c363648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c363648",
  null
  
)

export default component.exports